import {POSITION_END} from './positionEndTypes'

export const changepositionEnd = positionEnd => {
    return {
        type: POSITION_END,
        load: positionEnd
    }
}

export const selectNewPositionEnd = (positionEnd) => {

    return (dispatch) => {
        dispatch(changepositionEnd(positionEnd))
    }

}